"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDashboardInsightComponentSetFactory = void 0;
var dragAndDrop_1 = require("../../dragAndDrop/");
/**
 * @internal
 */
function DefaultDashboardInsightComponentSetFactory(insightProvider) {
    return {
        MainComponentProvider: insightProvider,
        dragging: {
            DraggingComponent: dragAndDrop_1.InsightDraggingComponent,
            type: "insight",
        },
        configuration: {
            WidgetConfigPanelComponent: function () { return null; },
        },
    };
}
exports.DefaultDashboardInsightComponentSetFactory = DefaultDashboardInsightComponentSetFactory;
//# sourceMappingURL=DefaultDashboardInsightComponentSetFactory.js.map